import { render, staticRenderFns } from "./bodyprint-info.vue?vue&type=template&id=3eab28fc"
import script from "./bodyprint-info.vue?vue&type=script&lang=js"
export * from "./bodyprint-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports